export default __webpack_public_path__ + "/static/media/login-background.af90062e.jpeg";